import {Routes} from './routes';

export default function isWelcomeRoute(pathname: string) {
  return pathname.startsWith(Routes.Welcome);
}
